import http from "../../../../../core/utils/apis/skillApi";

const getSkillsRequestsList = async (options) => {
  try {
    const response = await http({
      method: "GET",
      url: "/skills/",
      params: { ...options, isActivated: false }, 
    });
    return response.data;
  } catch (e) {
    console.error("Error fetching skills requests:", e);
    throw e;
  }
};

const activateSkill = async (id) => {
  try {
    const response = await http({
      method: "PATCH",
      url: `/skills/${id}/activate`,
    });
    return response.data;
  } catch (e) {
    console.error("Error activating skill:", e);
    throw e;
  }

};
const deleteSkill = async (id) => {
  try {
    const response = await http({
      method: "DELETE",
      url: `/skills/${id}`,
    });
    return response.data;
  } catch (e) {
    console.error("Error deleting skill:", e);
    throw e;
  }
};
const SkillsRequestsManagementService = {
  getSkillsRequestsList,
  activateSkill,
  deleteSkill
};

export default SkillsRequestsManagementService;
